import { ExternalLink, Pencil, Plus } from 'lucide-react'
import { patientService } from '../../../../services/patientApi'
import { ACTIVITY_STATUS, doseLabel } from './therapyFormat'

function statusClass(status) {
  if (status === 'ativa') return 'patients-badge patients-badge--estavel'
  if (status === 'pausada') return 'patients-badge patients-badge--observacao'
  return 'patients-badge patients-badge--neutral'
}

function TherapyPlan({ patientId, activities, archived, canCreate = false, onEdit, onCreate, onChanged }) {
  const changeStatus = (activity, status) => {
    onChanged(() => patientService.updateTherapyActivity(patientId, activity.id, { status }))
  }

  return (
    <section className="therapy-block therapy-plan" data-onboarding="therapy-plan">
      <div className="patients-section-head">
        <div>
          <h3>Plano de atividades prescritas</h3>
          <p className="patients-muted">Exercícios com frequência, séries, repetições e orientação para o domicílio.</p>
        </div>
        {!archived && canCreate && (
          <button type="button" onClick={onCreate} className="patients-btn patients-btn--primary">
            <Plus size={14} /> Nova atividade
          </button>
        )}
      </div>
      {activities.length === 0 && <p className="patients-muted">Nenhuma atividade prescrita.</p>}
      <div className="patients-stack">
        {activities.map((activity) => (
          <article key={activity.id} className="patients-panel therapy-card">
            <div className="patients-section-head">
              <div>
                <h3>{activity.title}</h3>
                <p className="patients-muted">{doseLabel(activity)}</p>
              </div>
              <span className={statusClass(activity.status)}>{ACTIVITY_STATUS[activity.status] || activity.status}</span>
            </div>
            {activity.guidance && <p className="therapy-guidance">{activity.guidance}</p>}
            {activity.media_url && (
              <a className="therapy-media" href={activity.media_url} target="_blank" rel="noreferrer">
                <ExternalLink size={14} /> Ver instrução
              </a>
            )}
            {!archived && (
              <div className="therapy-card-actions">
                <button type="button" onClick={() => onEdit(activity)} className="patients-btn patients-btn--ghost patients-btn--compact">
                  <Pencil size={14} /> Editar
                </button>
                {activity.status === 'ativa' && (
                  <button type="button" onClick={() => changeStatus(activity, 'pausada')} className="patients-btn patients-btn--ghost patients-btn--compact">Pausar</button>
                )}
                {activity.status === 'pausada' && (
                  <button type="button" onClick={() => changeStatus(activity, 'ativa')} className="patients-btn patients-btn--ghost patients-btn--compact">Retomar</button>
                )}
                {activity.status !== 'encerrada' && (
                  <button type="button" onClick={() => changeStatus(activity, 'encerrada')} className="patients-btn patients-btn--ghost patients-btn--compact">Encerrar</button>
                )}
                {activity.status === 'encerrada' && (
                  <button type="button" onClick={() => changeStatus(activity, 'ativa')} className="patients-btn patients-btn--ghost patients-btn--compact">Reativar</button>
                )}
              </div>
            )}
          </article>
        ))}
      </div>
    </section>
  )
}

export default TherapyPlan
